import { NAME, ORDER_FIELDS } from './order-fields.tsx';

export const ITEMS_ON_PAGE = 25;
export const PAGE = 1;
export const ORDER_FIELD: typeof NAME = NAME;
export const FILTER = '';
export const START_AT = 0;
export const ORDER = `+${ORDER_FIELDS[ORDER_FIELD]}`;
